module.exports = new __parcel__URL__("industry_icon.30d7df5b.svg").toString();